export * from '@kaidam/fc-shared/src/frontend/store/modules/snackbar'
import defaultModule from '@kaidam/fc-shared/src/frontend/store/modules/snackbar'
export default defaultModule